
import { Box } from '@mui/material';
import Heading from '../../text/Heading';
import Text from '../../text/Text';
import { ReactComponent as TableError } from '../../../../styles/svg/tableerror.svg'
import { useTranslation } from 'react-i18next';

const ShGridError = () => {
    const {t} = useTranslation();
    
    return (
        <Box 
            sx={{
                display:"flex",
                justifyContent:"center",
            }}
        >
            <Box
                sx={{
                    maxWidth:360,
                    display:"flex",
                    justifyContent:"center",
                    flexDirection:"column",
                    alignItems:"center"
                }}
            >
                <TableError/>
                <Box
                    sx={{
                        mt:3,
                        display:"flex",
                        flexDirection:"column",
                        gap:0.5
                    }}
                >
                    <Heading align="center">{t('grid_error_title')}</Heading>
                    <Text align="center" light>{t('grid_error_description')}</Text>
                </Box>
            </Box>
        </Box>
    );
}

export default ShGridError;